import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import RecordNotFound from "../../restaurant/shared/recordNotFound";
import { qrTableSelectionList } from "../../restaurant/services/table.service";
import { capitalizeFirstLetter  , TrimText , getUser} from "../../../utils/commonfunction"
import { QR_CODE_TYPES , ROLE} from "../../../utils/Constants"
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function QRTableSelection() {
  const [tableList, setTableList] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    setTableLoader(true);
    const formData = new FormData();
    const parts = location.pathname.split("/");
    const lastPart = parts[parts.length - 1];
    const restaurantId = lastPart.split("=")[1];
    formData.append("restaurant_id", restaurantId);
    formData.append("page", 1);
    formData.append("per_page", 200);
  
    qrTableSelectionList(formData)
      .then((data) => {
        if (data?.data) {
          // 🔥 FILTER available tables only
          const availableTables = data.data.filter(
            (table) => table.is_available === true
          );
          setTableList(availableTables);
        } else {
          setTableList([]);
        }
  
        setTableLoader(false);
      })
      .catch(() => setTableLoader(false));
  }, [location]);

   const generateQRUrl = () => {
      const userId = getUser(ROLE.RESTAURANT)?._id;
        let qrCodeData = {  
          restaurant_id: userId ,
          table_id: selectedTable._id,
          type: QR_CODE_TYPES.TABLE,
          base: "web",
        };
        const queryString = new URLSearchParams(qrCodeData).toString();
        let url = `${process.env.REACT_APP_WEB_BASE_URL}/qr-order?${queryString}`;
        window.location.href = url
    };

  return (
    <>
      <div className="qr-menu-right">
        {!tableLoader ? (
          <>
            {tableList.length ? (
              <div className="qr-menu-item-list" style={{
                        display: "flex",
                        gap: "10px",
                        margin: "10px 15px",
                        flexDirection: "column",
                    }}
                >
                {tableList.map((table, index) => {
                  const isSelected = selectedTable?._id === table._id;

                  return (
                    <div
                      className={
                        "qr-menu-item-col table-card" +
                        (isSelected ? " item-selected" : "")
                      }
                      key={index}
                      onClick={() => setSelectedTable(table)}
                    >
                      <figcaption>
                        <div className="d-flex justify-content-between">
                          <span className="fw-bold">{TrimText(table.table_number , 20)}</span>

                          <span style={{color : 'white'}}
                            className={
                              table.is_available
                                ? "badge bg-success"
                                : "badge bg-danger"
                            }
                          >
                            {table.is_available ? "Available" : "Occupied"}
                          </span>
                        </div>

                        <div className="mt-1 text-muted">
                          <div>{t("restaurant.table_management.label_shape")} : {capitalizeFirstLetter(table.shape)}</div>
                          <div>{t("restaurant.table_management.label_capacity")} : {table.capacity}</div>
                        </div>
                      </figcaption>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div>
                <RecordNotFound heading="No Tables Found" />
              </div>
            )}

            {/* Submit Button */}
            <div className="mt-3 text-center">
              <button
                className="btn btn-primary px-4"
                disabled={!selectedTable}
                onClick={() => generateQRUrl()}
              >
                {selectedTable
                  ? `Selected: ${selectedTable.table_number}`
                  : "Select Table"}
              </button>
            </div>
          </>
        ) : (
          // Skeleton Loader
          <div className="qr-menu-item-list">
            {[...Array(6)].map((_, i) => (
              <div className="qr-menu-item-col" key={i}>
                <Skeleton
                  style={{ height: "70px" }}
                  className="rounded-3 mb-3"
                />
                <figcaption>
                  <Skeleton containerClassName="d-flex" />
                  <Skeleton containerClassName="d-flex" />
                </figcaption>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
